module.exports = "/images/language-flags.png?6de99bf0053f5eb869e206f6fe550994";